export default "__VITE_ASSET__BRbPnQjl__"